import { allLessons } from './translations/index';

export type { Lesson } from '../utils/translation';

export const mockLessons = allLessons;
